import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import type * as models from '../../models'

export const DOC = gql`
  fragment FragmentUserForAgentAssignment on User {
    id
    lastName
    firstName
    isPlatformAdmin
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentUserForAgentAssignmentFragment,
  models.User
>({
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
  isPlatformAdmin: transformers.PASS_THROUGH,
  name: ({ firstName, lastName }) =>
    firstName && lastName
      ? `${firstName} ${lastName}`
      : (firstName ?? lastName ?? 'Unknown User'),
})
